import axios from 'axios'

export const PremiumBonusInsightsApi = {
    http: axios.create(),
    getInsightsSidebar(documentId) {
        return this.http.get(Routing.generate('get_document_tags', {documentId: documentId}));
    }
}
